<template>
  <div class="container">
    <Container :active_path="path" :plate="'项目巡览'">
      <div class="base-warp">
        <div class="head">
           <el-form :model="exportDataall" ref="form" label-width="80px" :inline="true" size="normal">
            <el-form-item label="福利名称">
              <el-input v-model="search.flname" size="mini" placeholder="请输入福利名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="mini" @click="confirm">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="mini" @click="exportData">导出</el-button>
            </el-form-item>
          </el-form>
          
          <el-form :model="search" ref="form" label-width="80px" :inline="true" size="normal">
            <el-form-item label="用户名称">
              <el-input v-model="search.name" size="mini" placeholder="请输入用户名称进行查询"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="mini" @click="confirm">搜索</el-button>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" size="mini" @click="addquan">添加会员券码</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-dialog v-bind="$attrs" v-on="$listeners" :visible.sync="dialogVisible" title="预约信息" width="30%">
            <el-row :gutter="20">
              <el-form ref="elForm" :model="formData" :rules="rules" size="small" label-width="100px" label-position="left">
                <el-col :span="20">
                  <el-form-item label="姓名" prop="uname">
                    <el-input v-model="formData.uname" show-word-limit prefix-icon='el-icon-s-opportunity'
                      :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="20">
                  <el-form-item label="手机号" prop="telephone">
                    <el-input v-model="formData.telephone" :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="20">
                  <el-form-item label="福利名称" prop="title">
                    <el-input v-model="formData.title" :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="20">
                  <el-form-item label="券码">
                    <el-input v-model="formData.qnum" disabled :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col> <el-col :span="20">
                  <el-form-item label="领取时间">
                    <el-input v-model="formData.addtime" disabled :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="20">
                  <el-form-item label="领取数量">
                    <el-input v-model="formData.lqnum" :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="20">
                  <el-form-item label="是否核销">
                    <el-radio v-model="formData.ishexiao" :label="1">是</el-radio>
                    <el-radio v-model="formData.ishexiao" :label="0">否</el-radio>
                  </el-form-item>
                </el-col>
                <el-col :span="20">
                  <el-form-item label="核销时间">
                    <el-input v-model="formData.hxtime" disabled :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="20">
                  <el-form-item label="备注">
                    <el-input v-model="formData.remark" type="textarea" placeholder=""
                      :autosize="{ minRows: 4, maxRows: 4 }" :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
            </el-row>
            <div slot="footer">
              <el-button @click="close">取消</el-button>
              <el-button type="primary" @click="handleConfirmAdd(formData)">新加领券信息</el-button>
              <el-button type="primary" @click="handleConfirm(formData)">确定核销</el-button>
            </div>
          </el-dialog>
        </div>

        <div class="table-box">
          <el-table :data="tabledata" border size="mini"
            :header-cell-style="{ background: '#f7f7f7', color: '#999', textAlign: 'center', fontWeight: 'normal' }">
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="title" label="福利名称" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="uname" label="用户名称" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="telephone" label="手机号" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="qnum" label="券码" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="lqnum" label="领取数量" show-overflow-tooltip align="center"></el-table-column>
            <!-- <el-table-column prop="companyname" label="公司名称" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="position" label="职位" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="content" label="意见反馈" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="reser_time" label="预约时间" show-overflow-tooltip align="center"></el-table-column> -->
            <!-- <el-table-column prop="ishexiao" label="是否核销" show-overflow-tooltip align="center"></el-table-column> -->
            <el-table-column prop="ishexiao" label="是否核销" align="center">
                            <template slot-scope="s">
                                <span class="text-success" v-if="s.row.ishexiao">已核销</span>
                                <span class="text-danger" v-else>未核销</span>
                            </template>
                        </el-table-column>
            <el-table-column prop="index" label="操作" width="160">
              <template slot-scope="s">
                <el-button type="danger" size="mini" @click="del(s.row)">删除</el-button>
                <el-button type="primary" size="mini" @click="edit(s.row)" plain>核销</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination class="page-tion" @current-change="currentChange" layout="prev, pager, next" :page-size="pagesize"
          :total="total" background>
        </el-pagination>
      </div>
    </Container>
    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
import Container from "../../../components/container"

export default {
  components: {
    Container,
  },
  data () {
    return {
      path: '/reallyWillBuy/memberorder',
      search: {
        name: '',
      },
      dialogVisible: false,
      pageNo: 1,
      pagesize: 14,
      formData: {
        id: '',
        uname: '',             //项目名称
        telephone: '',
        title: '',
        qnum: '',
        addtime: '',
        lqnum: '',
        ishexiao: 0,
        hxtime: '',
        remark: ''
      },

      tabledata: [],
      total: 0,
      imageUrl: '',
      rules: {
        uname: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }],
        telephone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }],
        title: [{
          required: true,
          message: '请输入福利名称',
          trigger: 'blur'
        }],
      }
    }
  },
  mounted () {
    this.getTableData();
  },
  methods: {
    edit (row) {
      this.dialogVisible = true
      this.formData = row
    },
    close () {
      this.dialogVisible = false
      this.getTableData()
    },
    handleConfirm (row) {
      console.log(row)
      if(row.ishexiao == 1){
        this.$confirm("是否确定核销 " + row.qnum + '会员券码吗').then(
          (confirm) => {
            var params = {
              id: row.id,
              lqnum: row.lqnum,
              remark: row.remark,
              ishexiao: row.ishexiao
            };
            this.$api.changeuserWelfareOrder(params).then((data) => {
              this.$message.success(data);
              this.getTableData();
            });
          },
          (cancel) => { }
        );
      }
      this.dialogVisible = false
      this.getTableData()
    },
    handleConfirmAdd (row) {
      //console.log(row)
      this.$refs['elForm'].validate(valid => {
        if (valid) {
          var params = {
              uname: row.uname,
              telephone: row.telephone,
              title: row.title,
              lqnum: row.lqnum,
              ishexiao: row.ishexiao,
              remark: row.remark
            };
            this.$api.adduserWelfareOrder(params).then((data) => {
              this.$message.success(data);
              this.getTableData();

              var that = this
              //that.$message.success('操作成功')
              that.dialogVisible = false
            });
        } else {
          this.$message.error('遇到了某些错误,请检查表单')
          return false;
        } 

      })
      // this.$confirm("是否确定新加 " + row.qnum + '会员券码？').then(
      //     (confirm) => {
            
      //     },
      //     (cancel) => { }
      //   );
      //this.dialogVisible = false
      //this.getTableData()
    },
    
    confirm () {
      this.pageNo = 1;
      this.getTableData();
    },
    addquan(){
      this.dialogVisible = true
      this.formData.id = null
      this.formData.uname = ''
      this.formData.telephone = ''
      this.formData.title = ''
      this.formData.qnum = ''
      this.formData.addtime = ''
      this.formData.lqnum = 1
      this.formData.ishexiao = 1
      this.formData.hxtime = ''
      this.formData.remark = ''
      //this.formData = []
      //this.pageNo = 1;
      //this.getTableData();
    },
    currentChange (page) {
      this.pageNo = page;
      this.getTableData();
    },
    del (row) {
      this.$confirm("是否确定删除 " + row.uname + '会员券码记录么').then(
        (confirm) => {
          var params = {
            id: row.id
          };
          this.$api.deluserWelfareOrder(params).then((data) => {
            this.$message.success(data);
            this.getTableData();
          });
        },
        (cancel) => { }
      );
    },
    getTableData () {
      var params = {
        name: this.search.name,
        pageNo: this.pageNo,
        pagesize:this.pagesize
      }
      this.$api.getuserWelfareOrder(params).then(data => {
        let { list, total } = data;
        this.tabledata = list;
        this.total = total;
      })
    },
  },

}
</script>

<style lang="scss" scoped>
.el-rate {
  display: inline-block;
  vertical-align: text-top;
}

.el-upload__tip {
  line-height: 1.2;
}

.right-edit-box {
  position: absolute;
  right: 0;
  top: 0;
}

.el-carousel__item {
  background: #fff;
  border: 1px dashed #999;

  .img {
    width: 270px;
    height: 202px;
    vertical-align: middle;
    position: relative;
  }

  .name {
    position: absolute;
    color: #fff;
    padding: 0 6px;
    background: rgba(0, 0, 0, 0.4);
    bottom: 4px;
    left: 4px;
  }
}

.left-row {
  border: 1px dashed #d9d9d9
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
  margin: 0 auto;
}
</style>